module.exports = __webpack_public_path__ + "img/153.3ab8ae20.jpg";